import { render, staticRenderFns } from "./StoreRewards.vue?vue&type=template&id=ae958464"
import script from "./StoreRewards.vue?vue&type=script&lang=js"
export * from "./StoreRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports